import { render, staticRenderFns } from "./AddCardForm.vue?vue&type=template&id=397d7eea"
import script from "./AddCardForm.vue?vue&type=script&lang=js"
export * from "./AddCardForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports